"use strict";

Shopify.theme.jsFeaturedProduct = {
  init: function init($section) {
    this.createSlider();
  },
  createSlider: function createSlider() {
    var slider = $('[data-slider]').flickity({
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      autoPlay:true,
      cellAlign:'left'
    }); // Reset layout to avoid collapsing issues
    
    
    setTimeout(function () {
      slider.flickity('resize');
    }, 500);
  },
  blockSelect: function blockSelect($section, blockId) {

  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};
   
